import React from 'react';


const CustomSelect = ({id, data, selectedName, selectedValue, selectValueKey, selectNameKey, sendDataToParent=null, onChange=null, all=false, disabled=false}) => {

    function liOnClick(name, value) {
        let selectElement = document.getElementById(id);
        let selectButton = document.getElementById(id + '-select-button');
        let filterOption = selectButton.querySelector('.filter-option.pull-left');
        selectButton.title = name;
        filterOption.textContent = name;
        selectElement.value = value;
        if (sendDataToParent) {
            sendDataToParent(name, value);
        }
        if (onChange && typeof onChange === 'function') {
            let changeEvent = new Event('change', {
                bubbles: true,
                cancelable: false
            });

            selectElement.dispatchEvent(changeEvent);
        }
    }

	// console.log("Merchant button disabled: " + disabled); 
	// console.log(data); 

    return (
        <div className="btn-group bootstrap-select">
            <button type="button" className="btn dropdown-toggle btn-round btn-simple" id={id + '-select-button'} data-toggle="dropdown" role="button" title={selectedName} aria-expanded="false" disabled={disabled}>
                <span className="filter-option pull-left">{selectedName}</span>&nbsp;<span className="bs-caret"><span className="caret"></span></span>
            </button>
            <div className="dropdown-menu" style={{maxHeight: "400px", overflow: "auto"}} role="combobox" x-placement="top-start">
                <ul className="dropdown-menu inner" role="listbox" aria-expanded="true">
                    {all === true &&
                        <li data-original-index="0">
                            <a tabIndex="0" className="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false" onClick={() => liOnClick("All", "")}>
                                <span className="text">All</span>
                                <span className="glyphicon glyphicon-ok check-mark"></span>
                            </a>
                        </li>
                    }
                    {data && data.length > 0 && data.map((value, index) => (
                        <li data-original-index={all === true ? 1+index : index} key={index} >
                            <a tabIndex="0" className="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false" onClick={() => liOnClick(value[selectNameKey], value[selectValueKey])}>
                                <span className="text">{value[selectNameKey]}</span>
                                <span className="glyphicon glyphicon-ok check-mark"></span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <select id={id} className="" tabIndex="-98" value={selectedValue} onChange={onChange} disabled={disabled}>
                {all === true &&
                    <option value="">All</option>
                }
                {data && data.length > 0 && data.map((value, index) => (
                    <option key={index} value={value[selectValueKey]}>{value[selectNameKey]}</option>
                ))}
            </select>
        </div>
    );
};

export default CustomSelect;
